/* One line, at most one truncated segment: earlier segments stay whole, the last gives way */
.line {
  display: flex;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
}

.segment {
  flex: 0 0 auto;
}

.truncates {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
